import { settings } from '../../engine/settings-sidecar'
import { websockets } from '../../engine/websockets-sidecar'
import { voyageGameManager } from './voyageGameManager-sidecar'
import { voyageGameMode_tutorial } from './voyageGameMode_tutorial-sidecar'
import { voyageSaver } from './voyageSaver-sidecar'
import { voyageTestParams } from './voyageTestParams-sidecar'
import { voyageToolBodyAlign } from './voyageToolBodyAlign-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

const namespace = 'voyage-loading'

export function* generator_loading(): Generator<number, number, number> {
  console.log(namespace, 'loading game!!')

  voyageToolBodyAlign.doLoad()
  while (!voyageToolBodyAlign.getIsLoaded()) {
    yield 0
  }

  let startingShip = 'small' // 'voyage

  if (!voyageTestParams.isDevMode) {
    voyageSaver.load(startingShip)
    voyageGameManager.goMenuMain()
  } else {
    let tm = voyageTestParams.loadTestMode()

    voyageSaver.load(settings.get().filename || startingShip)

    if (tm === 'editor') {
      voyageGameManager.goEditor()
    } else if (tm === 'game') {
      websockets.setSingleplayer(true)
      voyageGameManager.goGame()
      voyageGameMode_tutorial.signalSkip(true)
    } else if (tm === 'body-align') {
      voyageGameManager.goBodyAlign()
    } else {
      if (voyageTestParams.singleplayerAutoJoin) {
        websockets.setSingleplayer(true)
        voyageGameManager.goGame()
        voyageGameMode_tutorial.signalSkip(true)
      } else {
        voyageGameManager.goMenuMain()
      }
    }
  }

  return 0
}
